'use strict';

exports.__esModule = true;
exports.Tertiary = exports.Secondary = exports.Rule = exports.Footer = exports.Main = exports.Header = undefined;

var _Modal = require('./Modal2');

var _Modal2 = _interopRequireDefault(_Modal);

var _Rule = require('./Rule');

var _Rule2 = _interopRequireDefault(_Rule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Modal2.default;
exports.Header = _Modal.Header;
exports.Main = _Modal.Main;
exports.Footer = _Modal.Footer;
exports.Rule = _Rule2.default;
exports.Secondary = _Modal.Secondary;
exports.Tertiary = _Modal.Tertiary;


//////////////////
// WEBPACK FOOTER
// ./~/li-components/lib/Modal2/index.js
// module id = 2262
// module chunks = 14